export default "__VITE_ASSET__BPuMIf9A__"